import React, { useState, useEffect } from 'react';

import RupeeIcon from '../../../icons/Rupee';
import ArrowUp from '../../../icons/ArrowUp';
import ArrowDown from '../../../icons/ArrowDown';
import DiscountIcon from '../../../../../commonstories/src/icons/Discount';
import CircleSpinner from '../../Common/CircleSpinner/CircleSpinner';

import FareOptions from '../FareFamily/fare-family';
import FlightInfo from '../flight-info-details/flight-info-details';

import Route from './route';
import * as S from './srp-card-ui.styles';
import formatPrice from '@ibibo/format-price';

// const getEMIPriceInStr = flightItem => {
//   const price = flightItem.valuesForSort.cost;
//   const emiPrice = Math.ceil(price / 3);
//   return emiPrice.toLocaleString('en-IN');
// };

const FlightCardTags = ({ benefitTags = [], isCheapest, flightItem }) => {
  return (
    <div className="dF">
      {(benefitTags?.length &&
        benefitTags?.map((benefit, i) => {
          const { bgColor = [], tColor = [], icon = '', text = '' } = benefit || {};
          return (
            <S.BenefitTag bgColor={bgColor} textColor={tColor} className="dF alignItemsCenter">
              {(icon && <img src={icon} width="16" height="16" className="marginR10" />) || null}
              <span className="studentBaggageText" dangerouslySetInnerHTML={{ __html: text }} />
            </S.BenefitTag>
          );
        })) ||
        null}
      {isCheapest && (
        <S.PromoTag>
          <span className="cheapest dF alignItemsCenter">
            <span>Cheapest</span>
          </span>
        </S.PromoTag>
      )}
      {!isCheapest && !flightItem.isExtraSeatFlight && (
        <S.PromoTag>
          <span>&nbsp;</span>
        </S.PromoTag>
      )}
    </div>
  );
};

const SeoSrpCardUi = props => {
  const {
    flightItem,
    handleFlightSelection, // For Book Button
    isFlightSelected,
    airports, // For Flight Details
    commonRulesData,
    callCommonRulesAPI,
    isRoundTrip,
    isDomesticRoundTrip,
    logPDT,
    pushGAEvents,
    pushAnalyticsEvents,
    typeOfTravel,
    onwardMinPrice,
    staticInformation,
    list,
    staticTexts,
    postSearchRkeysData,
    handlePriceLockTagClick = () => {},
    selectedFlight,
    showLoaderOnBookButton = false,
    offerInfo,
    messageValues
  } = props;
  const {
    priceToDisplay,
    slashedFare,
    // offerInfo,
    discountedFare,
    discount,
    disMessage,
    flightArr,
    multiCheckingText,
    handBaggageOnly,
    benefitTagData
  } = flightItem;

  const { t: bookButtonText = 'BOOK', bg: bookButtonBgColor } =
    staticTexts?.cta?.sd?.r_cta?.cd?.book || {};
  const price = discountedFare ? discountedFare : priceToDisplay;
  const isCheapest =
    price && parseInt(price.replace(',', ''), 10) === onwardMinPrice ? true : false;

  // const isMulti = flightItem?.valuesForSort?.carrier === 'multi';
  const isIntl = typeOfTravel && typeOfTravel.includes('international') ? true : false;
  const hasLayover = flightArr && flightArr.length > 1 ? true : false;

  const [deals, setShowDeals] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setShowDeals(false);
    }, 2000);
    if (flightItem.discountApply === 3) {
      logPDT({ action_name: 'stealdeal_shown_srp' });
    }
  }, []);

  const getVisaRequired = flightArr => {
    let visaRequired = false;
    flightArr &&
      flightArr.map(f => {
        if (f.visaRequired === true) {
          visaRequired = true;
          return;
        }
      });
    return visaRequired;
  };

  const visaRequired = getVisaRequired(flightArr);

  const [isBookButtonClicked, setIsBookButtonClicked] = useState(false);

  useEffect(() => {
    if (!isFlightSelected && isBookButtonClicked) {
      setIsBookButtonClicked(false);
    }
  }, [isFlightSelected]);

  const handleBookClick = () => {
    if (!isBookButtonClicked) {
      setIsBookButtonClicked(true);
      handleFlightSelection(flightItem);
    }
  };

  const handleFaresBookClick = anc_index => {
    const flightItemSelected = {
      ...flightItem,
      bundleIndex: anc_index,
      anc_index
    };
    handleFlightSelection(flightItemSelected);
  };

  const getLayoverText = flights => {
    const hasOfferText = !isAlternateFlight && offerInfo?.offerText ? true : false;
    const flightsSlicedArray = !hasOfferText ? flights.slice(1) : flights.slice(1, 4);
    const carrierNameText = `${flightsSlicedArray
      .map(f => `${f.depText} ${f.layoverInfo}`)
      .join(', ')}`;
    return `Layover${flights.length > 2 ? 's' : ''} - ${carrierNameText}${
      hasOfferText && flights.length > 4 ? '...' : ''
    }`;
  };

  const isAlternateFlight = flightItem && flightItem?.alternateText;
  const hasMultipleFares = !!flightItem.ancillaryList && !isAlternateFlight;

  const [isExpanded, setIsExpanded] = useState(false);
  const [showMultipleFares, setShowMultipleFares] = useState(false);

  const ViewFareClickHandler = () => {
    handleViewFaresClickHandlerAnalytics();
    setShowMultipleFares(!showMultipleFares);
  };

  const handleViewFaresClickHandlerAnalytics = () => {
    if (showMultipleFares && logPDT) {
      logPDT({ action_name: 'hide_fare_clicked' });
    }
    if (pushGAEvents) pushGAEvents('see_fares', 'flexi', !showMultipleFares, '');

    if (pushAnalyticsEvents) {
      pushAnalyticsEvents({
        pageType: 'SRP',
        eventName: showMultipleFares ? 'hideFare' : 'viewFares'
      });
      if (!showMultipleFares && flightItem && Array.isArray(flightArr)) {
        const pdtInfo = {
          action_name: 'view_prices_clicked'
        };
        const product = [];
        const { omnitureData, pdtData } = getLogDetails(flightArr);
        product.push(...omnitureData);
        if (pdtData?.category) {
          pdtInfo['meta_data'] = {
            category: pdtData.category
          };
        }
        if (pdtData?.subtype) {
          pdtInfo['meta_data'] = {
            ...pdtInfo['meta_data'],
            subtype: pdtData.subtype
          };
        }
        if (flightItem.returnFlight) {
          const { omnitureData, pdtData } = getLogDetails(
            flightItem?.returnFlight?.flightArr,
            true
          );
          product.push(...omnitureData);
          if (pdtData?.category) {
            const category = pdtInfo['meta_data'].category
              ? `${pdtInfo['meta_data'].category}|${pdtData.category}`
              : pdtData.category;
            pdtInfo['meta_data'] = {
              ...pdtInfo['meta_data'],
              category
            };
          }
        }
        pushAnalyticsEvents({
          pageType: 'SRP',
          eventName: 'viewFare',
          data: { product },
          pdtInfo
        });
      }
    }
  };

  const getLogDetails = (arr, isReturn = false) => {
    const omnitureData = [];
    const category = [];
    const fareFamily = (
      flightItem?.ancillaryList.map(ff => (ff.isCustomFareFamily ? 'GOLUXE' : ff.header)) || []
    ).join('|');
    for (let i = 0; i < arr.length; i++) {
      const leg = arr[i];
      const flight = `${leg.flightNumber.slice(0, 2)}-${leg.flightNumber.slice(2)}`;
      omnitureData.push({
        SKU: flight,
        index: isReturn ? '2' : '1',
        airline: leg?.carrier?.carrierName,
        fareFamily
      });
      category.push(flight);
    }
    return { omnitureData, pdtData: { category: category.join('|'), subtype: fareFamily } };
  };

  const FlightDetailsClickHandler = () => {
    if (pushGAEvents)
      pushGAEvents(
        'fltViewDetails_' + typeOfTravel.toLowerCase(),
        isExpanded ? 'collapse' : 'expand',
        '',
        ''
      );

    if (pushAnalyticsEvents)
      pushAnalyticsEvents({
        pageType: 'SRP',
        eventName: isExpanded ? 'flightDetailsDropdownCollapsed' : 'flightDetailsDropdownExpanded'
      });

    setIsExpanded(!isExpanded);
  };

  const dailyStealDealsClicked = () => {
    logPDT({ action_name: 'stealdeal_srp_click' });
  };

  return (
    <S.SeoCard isDomesticRoundTrip={isDomesticRoundTrip}>
      <div className="dF justifyEnd">
        {isAlternateFlight ? (
          <div className="dF justifyBetween width100 marginB10">
            <S.AlternateText>
              <span className="f500">{flightItem.alternateText}</span>
            </S.AlternateText>
            <S.AlternateSaveText>
              <span className="f500">
                You save ₹{flightItem.alternateSavings.toLocaleString('en-IN')}
              </span>
            </S.AlternateSaveText>
          </div>
        ) : null}

        {flightItem?.isExtraSeatFlight ? (
          <S.FareFamilyHeaderWrapper>
            <S.FareFamilyHeader>
              <span className="f500">
                {`${flightItem?.extraSeatType === 7 ? '+1' : '+2'} Extra Seat`}
              </span>
            </S.FareFamilyHeader>
          </S.FareFamilyHeaderWrapper>
        ) : null}

        <FlightCardTags
          benefitTags={benefitTagData}
          isCheapest={isCheapest}
          flightItem={flightItem}
        />
      </div>

      <S.CardWrap className="width100 dF">
        <S.CardLeft>
          <Route flightItem={flightItem} />
          {flightItem.returnFlight ? <S.BrdrBtmDash className="marginT10 marginB10" /> : null}
          {flightItem.returnFlight ? <Route flightItem={flightItem.returnFlight} /> : null}
        </S.CardLeft>

        <S.CardRight className={`dF justifyEnd ${isIntl && isRoundTrip ? 'alignItemsCenter' : ''}`}>
          <S.PriceWrap className="flexCol justifyEnd">
            {discount ? (
              <S.DiscountWrap className="fmtTooltip">
                <i className="icon-offer-badge yellow ico20 padR5"></i>
                <i className="icon-rupee ico8"></i>
                <span className="ico12 f500 padR3">{discount}</span>
                <i className="icon-arrow-right ico8"></i>
                <div className="tip tip_btm white ">
                  <div className="f500">{disMessage}</div>
                </div>
              </S.DiscountWrap>
            ) : null}
            <div className="alignItemsEnd flexCol padB5">
              {slashedFare ? (
                <S.SlashedFare className="strike alignItemsCenter greyCnt dF">
                  {formatPrice(slashedFare)}
                </S.SlashedFare>
              ) : (
                <span className="alignItemsCenter greyCnt dF">
                  <span>&nbsp;</span>
                </span>
              )}
              <S.Price className="alignItemsCenter dF f600">
                <RupeeIcon fill="#141823" width="1.2rem" height="1.2rem" />
                {price}
              </S.Price>
            </div>
          </S.PriceWrap>

          <S.BookWrap className="justifyCenter flexCol alignItemsEnd padB5">
            <S.BookBtWrap className="flexCol width100">
              <S.LockButtonPlaceholder>&nbsp;</S.LockButtonPlaceholder>
              <S.BookButton
                className="dF justifyCenter alignItemsCenter f600"
                bgColor={!hasMultipleFares ? bookButtonBgColor : []}
                onClick={hasMultipleFares ? ViewFareClickHandler : handleBookClick}
              >
                {hasMultipleFares ? (
                  showMultipleFares ? (
                    'HIDE FARE'
                  ) : (
                    'VIEW FARES'
                  )
                ) : (
                  <>
                    {showLoaderOnBookButton &&
                      flightItem?.originalIndex === selectedFlight?.originalIndex && (
                        <CircleSpinner bkFlt={true} />
                      )}
                    <span>{bookButtonText}</span>
                  </>
                )}
              </S.BookButton>
            </S.BookBtWrap>
          </S.BookWrap>
        </S.CardRight>
      </S.CardWrap>

      <div className="dF justifyBetween width100 padLR20">
        <S.LayoverOfferWrap className="dF justifyBetween ">
          {hasLayover ? (
            <div className="greyCnt">{getLayoverText(flightArr)}</div>
          ) : (
            <div className="greyCnt">&nbsp;</div>
          )}
          {!isAlternateFlight && offerInfo?.offerText ? (
            <S.FlySmart
              className={'dF alignItemsCenter ' + (deals && list === 1 ? 'showOnce' : '')}
            >
              <S.OfferText className="padR5" color={offerInfo?.offerColor}>
                {offerInfo.offerText}
              </S.OfferText>
              {flightItem?.discountApply === 3 && staticInformation?.dsi ? (
                <>
                  <img
                    src={staticInformation?.dsi?.ti}
                    width="10"
                    height="14"
                    onClick={dailyStealDealsClicked}
                    alt="daily_steal_deals"
                  />
                  <div className="dailyStealDeal">
                    <p className="marginB4">
                      <img
                        src={staticInformation?.dsi?.sdi}
                        width="137"
                        height="11"
                        alt="daily_steal_deals_static_info"
                      />
                    </p>
                    <p className="dF alignItemsCenter">
                      <img
                        src={staticInformation?.dsi?.ti}
                        width="13"
                        height="18"
                        alt="daily_steal_deals_static_info_ti"
                      />
                      <span className="marginL3 f500">{staticInformation?.dsi?.tm}</span>
                    </p>
                  </div>
                </>
              ) : (
                <DiscountIcon width="1.2rem" height="1.2rem" />
              )}
            </S.FlySmart>
          ) : null}
        </S.LayoverOfferWrap>
      </div>
      <S.CardFooter className="dF width100 justifyBetween alignItemsEnd">
        <div className="dF alignItemsCenter">
          {visaRequired && (
            <span className="dF alignItemsCenter marginR5">
              <DiscountIcon width="1.5rem" height="1.5rem" />
              <span className="padL5 greyCnt"> Transit Visa required </span>
            </span>
          )}

          {multiCheckingText ? (
            <S.MultiBanner>
              <S.MultiBannerTag>{multiCheckingText}</S.MultiBannerTag>
              <span className="padL5 greyCnt">Baggage re-check will be required</span>
            </S.MultiBanner>
          ) : null}
          {handBaggageOnly && (
            <span className="padT5 dF alignItemsCenter">
              {visaRequired || multiCheckingText ? (
                <S.BorderSpan className="marginL5">|</S.BorderSpan>
              ) : null}
              <S.HandBaggage
                dangerouslySetInnerHTML={{ __html: handBaggageOnly?.text }}
                bgColor={handBaggageOnly?.bgColor}
                className={visaRequired || multiCheckingText ? 'marginL5' : ''}
              ></S.HandBaggage>
            </span>
          )}
          {/* {flightItem.refundability}{' '} */}
          {flightItem.footerText !== '' ? (
            <span className="padT5 greyCnt padL5"> {flightItem.footerText}</span>
          ) : null}
        </div>
        <div onClick={FlightDetailsClickHandler}>
          <a className="dF alignItemsCenter curPointFlt alignItemsCenter fr">
            <span className="blueCnt padR5 f500">Flight Details</span>
            {isExpanded ? (
              <ArrowUp width="1rem" height="1rem" />
            ) : (
              <ArrowDown width="1rem" height="1rem" />
            )}
          </a>
        </div>
      </S.CardFooter>
      {isExpanded ? (
        <FlightInfo
          flightItem={flightItem}
          airports={airports}
          commonRulesData={commonRulesData}
          callCommonRulesAPI={callCommonRulesAPI}
          logPDT={logPDT}
          pushGAEvents={pushGAEvents}
          pushAnalyticsEvents={pushAnalyticsEvents}
          typeOfTravel={typeOfTravel}
        />
      ) : null}
      {hasMultipleFares && showMultipleFares ? (
        <FareOptions
          staticTexts={staticTexts}
          postSearchRkeysData={postSearchRkeysData}
          ancillaryList={flightItem.ancillaryList}
          onBookClickHandler={handleFaresBookClick}
          handlePriceLockTagClick={handlePriceLockTagClick}
          selectedFlight={selectedFlight}
          showLoaderOnBookButton={showLoaderOnBookButton}
          messageValues={messageValues}
        />
      ) : null}
    </S.SeoCard>
  );
};

export default SeoSrpCardUi;
